const convertToNumberOrNull = raw => {
  return Number.isNaN(+raw) ? null : +raw;
};

const mapData = d => {
  const copy = { ...d };

  if (d.OPENADMP === '1') {
    copy.ADM_RATE = 1;
  } else {
    copy.ADM_RATE = convertToNumberOrNull(d.ADM_RATE);
  }

  copy.UGDS = convertToNumberOrNull(d.UGDS);

  copy.averageCost = convertToNumberOrNull(d.averageCost);
  copy.netPrice = convertToNumberOrNull(d.netPrice);

  copy.onTimeCompletionRate = convertToNumberOrNull(d.onTimeCompletionRate);
  copy.extraTimeCompletionRate = convertToNumberOrNull(d.extraTimeCompletionRate);

  copy.TUITIONFEE_IN = convertToNumberOrNull(d.TUITIONFEE_IN);
  copy.TUITIONFEE_OUT = convertToNumberOrNull(d.TUITIONFEE_OUT);

  copy.ACTCM25 = convertToNumberOrNull(d.ACTCM25);
  copy.ACTCM75 = convertToNumberOrNull(d.ACTCM75);
  copy.ACTCMMID = convertToNumberOrNull(d.ACTCMMID);

  const SATMT25 = convertToNumberOrNull(d.SATMT25);
  const SATVR25 = convertToNumberOrNull(d.SATVR25);
  copy.satCombined25 = SATMT25 === null || SATVR25 === null ? null : SATMT25 + SATVR25;

  const SATMT75 = convertToNumberOrNull(d.SATMT75);
  const SATVR75 = convertToNumberOrNull(d.SATVR75);
  copy.satCombined75 = SATMT75 === null || SATVR75 === null ? null : SATMT75 + SATVR75;

  const SATMTMID = convertToNumberOrNull(d.SATMTMID);
  const SATVRMID = convertToNumberOrNull(d.SATVRMID);
  copy.satCombinedMid = SATMTMID === null || SATVRMID === null ? null : SATMTMID + SATVRMID;

  copy.MN_EARN_WNE_P6 = convertToNumberOrNull(d.MN_EARN_WNE_P6);
  copy.MN_EARN_WNE_P10 = convertToNumberOrNull(d.MN_EARN_WNE_P10);

  copy.RPY_3YR_RT = convertToNumberOrNull(d.RPY_3YR_RT);
  copy.RPY_7YR_RT = convertToNumberOrNull(d.RPY_7YR_RT);

  copy.fourYear = d.fourYear === 'TRUE';

  return copy;
};

export { mapData };



// WEBPACK FOOTER //
// ./src/App/DataMapper.js